// features/subscription/couponVerifySlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET } from "../../../utils/Methods"; 
import { APIS } from "../../../utils/APIS";
import { IDS } from "../../../utils/IDS";

// 🔹 Async Thunk: Verify Coupon
export const VerifyCoupon = createAsyncThunk(
  "coupon/verify",
  async (data, { rejectWithValue }) => {
    try {
      const { user_id, coupon_code, subscription_id } = data;

      // Build query params
      const query = `?user_id=${user_id}&coupon_code=${coupon_code}&subscription_id=${subscription_id}`;

      // API call (GET request as per your Postman link)
      const res = await GET(`${APIS.Register.VERIFY_COUPON}${query}`);

      console.log("Coupon Verify Response:", res);
      return res;
    } catch (error) {
      console.error("Coupon Verify API Error:", error);
      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

// 🔹 Slice
const couponVerifySlice = createSlice({
  name: "couponVerify",
  initialState: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  reducers: {
    resetCouponVerifyState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(VerifyCoupon.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(VerifyCoupon.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(VerifyCoupon.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { resetCouponVerifyState } = couponVerifySlice.actions;

export default couponVerifySlice.reducer;
